import { withSagas } from 'metrix-common3';
import { Children, cloneElement, isValidElement, useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import getCRMWebConfiguration from '../../actions/CRMWebConfiguration/getCRMWebConfiguration';
import reduceCRMWebConfiguration from '../../actions/CRMWebConfiguration/reduceCRMWebConfiguration';
import CRMWebConfigurationSaga from '../../sagas/CRMWebConfiguration/saga';
import { selectCRMWebConfiguration } from '../../selectors/CRMWebConfiguration/selectCRMWebConfiguration';

const propagatePropsToChildren = (children, newProps) =>
    Children.map(children, (child) => {
        if (!child) return child;
        // Don't propagate to HTML elements (e.g. div) — only React components
        if (isValidElement(child) && child.props && typeof child.type !== 'string') {
            return cloneElement(child, newProps);
        }
        return child;
    });

const CRMWebProvider = (props) => {
    // biome-ignore lint/correctness/useExhaustiveDependencies: mount-only init
    useEffect(() => {
        if (props.context.offline) {
            props.doReduceCRMWebConfiguration({});
        } else {
            props.doGetCRMWebConfiguration();
        }
    }, []);

    const context = {
        ...props.context,
        CRMWebConfiguration: props.CRMWebConfiguration || {},
    };
    const child = propagatePropsToChildren(props.children, { context })[0];
    return <>{child}</>;
};

const mapStateToProps = createStructuredSelector({
    CRMWebConfiguration: selectCRMWebConfiguration(),
});

const mapDispatchToProps = (dispatch) => ({
    doGetCRMWebConfiguration: () => dispatch(getCRMWebConfiguration()),
    doReduceCRMWebConfiguration: (payload) => dispatch(reduceCRMWebConfiguration(payload)),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withSaga = withSagas({ key: 'CRMWebConfiguration', saga: CRMWebConfigurationSaga });

export default compose(withConnect, withSaga)(CRMWebProvider);
